module.exports = __webpack_public_path__ + "static/media/get_variable.ccad6cc0.svg";